// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1-HPV","content":"GlobalSearch_content__q4hlK"};